module.exports = __webpack_public_path__ + "img/ic-pie.5decab4b.svg";